// APIs
import friendsApi from 'lib/api/friends';
import watchlistApi from 'lib/api/watchlist';
import { FOLLOW_ACTION, IDeleteSuggestedItem, IFollowMutation, USER_SUGGESTED_FILTER } from './constants';

export const getSuggestedPeople = async () => {
  const { data } = await friendsApi.getSuggestFriends({
    page: 1,
    limit: 30,
    filter: USER_SUGGESTED_FILTER.FILTER_UNSPECIFIED,
  });

  if (!data || data.error) {
    throw new Error('Attempt to get suggested people failed!');
  }

  return data?.data || [];
};

export const followUser = async ({ userid, type }: IFollowMutation) => {
  if (!userid) {
    throw new Error('User id is empty');
  }

  let targetAPI = watchlistApi.postFollowUser;

  if (type === FOLLOW_ACTION.UNFOLLOW) {
    targetAPI = watchlistApi.postUnfollowUser;
  }

  const response = await targetAPI(userid);

  if (!response.data) {
    throw new Error('Attempt to follow user failed');
  }
  const { error_type: error, message, data } = response.data;

  if (error) {
    return { error, message };
  }

  return { data, message, type, userid };
};

export const deleteSuggestedItem = async (body: IDeleteSuggestedItem) =>
  body.id;
